<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <div class="card card-shadow">
          <div class="card-header">
            <h4>{{ translate('subtest-attempt.admin_title') }}</h4>
          </div>
          <div class="card-body p4">
            <div v-if="['writing', 'complete'].includes(subtestAttempt.subtest.subtest_type.name)">
              <div class="subtest-type">
                  <span class="title d-flex justify-content-between">
                      <span>
                          <img alt="reading" src="/images/icon1.svg" height="20px">
                          {{ translate('subtest-attempt.reading') }}
                      </span>
                      <span class="badge-danger px-1 rounded"
                            v-if="subtestAttempt.writing_status === 'cancelled'">
                          {{ translate('subtest-attempts.canceled_status.cancelled') }}
                      </span>
                  </span>

                <hr>

                <h5>{{ translate('subtest-attempt.subtest_files') }}</h5>

                <div class="subtest-file" v-for="file in subtestAttempt.subtest.reading_files">
                  <a :href="file.url" download>
                    <span class="fa fa-download mr-1"></span> {{ file.original_name }}
                  </a>
                </div>

                <div v-if="subtestAttempt.submitted_reading_files.length > 0">
                  <hr>
                  <h5>{{ translate('subtest-attempt.submitted_by_student') }}</h5>

                  <a :href="subtestAttempt.submitted_reading_files[0].url"
                     :download="subtestAttempt.submitted_reading_files[0].original_name">
                    <span class="fa fa-download mr-1"></span>
                    {{ subtestAttempt.submitted_reading_files[0].original_name }}
                  </a>
                </div>
              </div>

              <div class="subtest-type">
                  <span class="title d-flex justify-content-between">
                      <span>
                          <img alt="listening" src="/images/icon2.svg" height="20px">
                          {{ translate('subtest-attempt.listening') }}
                      </span>
                      <span class="badge-danger px-1 rounded"
                            v-if="subtestAttempt.writing_status === 'cancelled'">
                          {{ translate('subtest-attempts.canceled_status.cancelled') }}
                      </span>
                  </span>
                <hr>
                <h5>{{ translate('subtest-attempt.subtest_files') }}</h5>
                <div class="subtest-file" v-for="file in subtestAttempt.subtest.listening_files">
                  <a :href="file.url" download>
                    <span class="fa fa-download mr-1"></span> {{ file.original_name }}
                  </a>
                </div>
                <div v-if="subtestAttempt.submitted_listening_files.length > 0">
                  <hr>
                  <h5>{{ translate('subtest-attempt.submitted_by_student') }}</h5>

                  <a :href="subtestAttempt.submitted_listening_files[0].url"
                     :download="subtestAttempt.submitted_listening_files[0].original_name">
                    <span class="fa fa-download mr-1"></span>
                    {{ subtestAttempt.submitted_listening_files[0].original_name }}
                  </a>
                </div>
              </div>

              <div class="subtest-type">
                  <span class="title d-flex justify-content-between">
                      <span>
                          <img alt="writing" src="/images/icon3.svg" height="20px">
                          {{ translate('subtest-attempt.writing') }}
                      </span>
                      <span class="badge-danger px-1 rounded"
                            v-if="subtestAttempt.writing_status === 'cancelled'">
                          {{ translate('subtest-attempts.canceled_status.' + subtestAttempt.writing_status) }}
                      </span>
                  </span>
                <hr>
                <h5>{{ translate('subtest-attempt.subtest_files') }}</h5>
                <div class="subtest-file" v-for="file in subtestAttempt.subtest.writing_files">
                  <a :href="file.url" download>
                    <span class="fa fa-download mr-1"></span> {{ file.original_name }}
                  </a>
                </div>
                <div v-if="subtestAttempt.submitted_writing_files.length > 0">
                  <hr>
                  <h5>{{ translate('subtest-attempt.submitted_by_student') }}</h5>

                  <a :href="subtestAttempt.submitted_writing_files[0].url"
                     :download="subtestAttempt.submitted_writing_files[0].original_name">
                    <span class="fa fa-download mr-1"></span>
                    {{ subtestAttempt.submitted_writing_files[0].original_name }}
                  </a>
                </div>
              </div>
            </div>

            <div class="subtest-type"
                 v-if="['speaking', 'complete'].includes(subtestAttempt.subtest.subtest_type.name)">
                <span class="title d-flex justify-content-between">
                    <span>
                        <img alt="speaking" src="/images/icon4.svg" height="20px">
                        {{ translate('subtest-attempt.speaking') }}
                    </span>
                    <span class="badge-danger px-1 rounded"
                          v-if="subtestAttempt.speaking_status === 'cancelled'">
                        {{ translate('subtest-attempts.canceled_status.' + subtestAttempt.speaking_status) }}
                    </span>
                </span>
              <hr>

              <div class="subtest-file" v-for="file in subtestAttempt.subtest.speaking_files">
                <a :href="file.url" download>
                  <span class="fa fa-download mr-1"></span> {{ file.original_name }}
                </a>
              </div>

              <h5>{{ translate('subtest-attempt.meeting_info.title') }}</h5>

              <p v-if="subtestAttempt.student">
                {{ translate('subtest-attempt.meeting_info.line_1') }}
                <br>
                {{ translate('subtest-attempt.meeting_info.line_2') }}:
                <br>
                {{ translate('subtest-attempt.meeting_info.platform') }}: {{ subtestAttempt.platform | capitalize }}
                <br>
                {{ translate('subtest-attempt.meeting_info.link') }}: {{ subtestAttempt.platform_id }}
                <br>
                {{ translate('subtest-attempt.meeting_info.by_email') }}: {{ subtestAttempt.student.email }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card card-shadow">
          <div class="card-header">
            <h1 class="h4">{{ translate('previews.subtest-attempt.title') }}</h1>
          </div>
          <div class="card-body p-4">
            <div class="row">
              <div class="col-lg-12 text-center">
                <img height="400px" class="border shadow" :src="subtestAttempt.subtest.image_path"
                     alt="subtest_cover">
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-12">
                <ul style="list-style-type: none; padding-inline-start: 0" class="mb-0">
                  <li>
                    {{ translate('previews.info.test-type') }}: <span class="font-weight-bold">
                      {{ subtestAttempt.subtest.test_type.title }}</span>
                  </li>
                  <li>
                    {{ translate('previews.info.subtest-type') }}: <span class="font-weight-bold">
                      {{ subtestAttempt.subtest.subtest_type.title_de }}</span>
                  </li>
                  <li>
                    {{ translate('previews.info.test-variation') }}: <span class="font-weight-bold">
                      {{ subtestAttempt.subtest.test_variation.title_de }}</span>
                  </li>
                </ul>
              </div>
            </div>

            <hr>

            <div class="row mt-2" v-if="subtestAttempt.student">
              <div class="col-md-12" v-if="subtestAttempt.student">
                  <span class="font-weight-bold">
                      {{ translate('previews.subtest-attempt.info.student') }}:
                  </span>{{ subtestAttempt.student.name }}
              </div>
              <hr>
            </div>

            <div class="row mt-2" v-if="subtestAttempt.reviewer">
              <div class="col-md-12" v-if="subtestAttempt.reviewer">
                  <span class="font-weight-bold">
                      {{ translate('previews.subtest-attempt.info.reviewer') }}:
                  </span>
                {{ subtestAttempt.reviewer.name }}
              </div>
              <div class="col-md-12" v-if="subtestAttempt.writing_module_grade">
                  <span class="font-weight-bold">
                      {{ translate('previews.subtest-attempt.info.writing_module_grade') }}:
                  </span>
                {{ subtestAttempt.writing_module_grade }}
              </div>

              <div class="col-md-12" v-if="subtestAttempt.speaking_module_grade">
                  <span class="font-weight-bold">
                      {{ translate('previews.subtest-attempt.info.speaking_module_grade') }}:
                  </span>
                {{ subtestAttempt.speaking_module_grade }}
              </div>

              <div class="col-md-12" v-if="subtestAttempt.notes">
                  <span class="font-weight-bold">
                      {{ translate('previews.subtest-attempt.info.notes') }}:
                  </span>
                {{ subtestAttempt.notes }}
              </div>
              <div class="col-md-12" v-if="subtestAttempt.completed_files.length > 0">
                  <span class="font-weight-bold">
                      {{ translate('previews.subtest-attempt.info.download-completed-subtest') }}:
                  </span>
                <a :href="subtestAttempt.completed_files[0].url"
                   :download="subtestAttempt.completed_files[0].original_name">
                  <span class="fa fa-download mr-1"></span>
                  {{ subtestAttempt.completed_files[0].original_name }}
                </a>
              </div>

              <hr>
            </div>


            <div class="row">
              <div class="col-md-12 mt-2" v-if="showAssignButton">
                <button class="btn btn-block btn-success" @click="editSubtestAttempt('assign')">
                  <span class="fa fa-link mr-1"></span>
                  {{ translate('previews.subtest-attempt.buttons.assign') }}
                </button>
              </div>

              <div class="col-md-12 mt-2" v-if="showResolveSpeakingCancellationButton">
                <button class="btn btn-block btn-primary"
                        @click="editSubtestAttempt('cancel', 'speaking')">
                  <span class="fas fa-wrench mr-1"></span>
                  {{ translate('previews.subtest-attempt.buttons.resolve-speaking-cancellation') }}
                </button>
              </div>

              <div class="col-md-12 mt-2" v-if="showResolveWritingCancellationButton">
                <button class="btn btn-block btn-primary"
                        @click="editSubtestAttempt('cancel', 'writing')">
                  <span class="fas fa-wrench mr-1"></span>
                  {{ translate('previews.subtest-attempt.buttons.resolve-writing-cancellation') }}
                </button>
              </div>

              <div class="col-md-12 mt-2" v-if="showUpdatePlatformButton">
                <button class="btn btn-block btn-primary"
                        @click="editSubtestAttempt('update-platform')">
                  <span class="fas fa-wrench mr-1"></span>
                  {{ translate('previews.subtest-attempt.buttons.update-platform') }}
                </button>
              </div>

              <div class="col-md-12 text-center mt-2" v-if="showUpdateSpeakingStatusButton">
                <button class="btn w-50 btn-primary"
                        @click="editSubtestAttempt('update-speaking-status')">
                  <span class="far fa-edit mr-1"></span>
                  {{ translate('previews.subtest-attempt.buttons.update-speaking-status') }}
                </button>
              </div>

              <div class="col-md-12 text-center mt-2" v-if="showReviewButtons">
                  <span class="fa fa-check-circle fa-2x next-to-button-icon mr-1"
                        :class="graded ? 'text-success' : 'text-secondary'">
                  </span>
                <button class="btn w-50 btn-success" @click="editSubtestAttempt('grade')">
                  {{ translate('previews.subtest-attempt.buttons.grade') }}
                </button>
              </div>

              <div class="col-md-12 text-center mt-2" v-if="showReviewButtons">
                  <span class="fa fa-file-pdf fa-2x next-to-button-icon mr-1"
                        :class="reviewed ? 'text-success' : 'text-secondary'">
                  </span>
                <button class="btn w-50 btn-success" @click="editSubtestAttempt('feedback')">
                  {{ translate('previews.subtest-attempt.buttons.feedback') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['subtestAttempt'],

  computed: {
    showReviewButtons () {
      let isReviewer = App.role === 'reviewer' && this.subtestAttempt.reviewer_id === App.user.id;

      if (this.subtestAttempt.subtest.subtest_type_id === 4) {
        return isReviewer && moment().isAfter(moment(this.subtestAttempt.speaking_appointment_at));
      }

      return isReviewer && ['completed', 'submitted'].includes(this.subtestAttempt.status);
    },

    showAssignButton () {
      return App.role === 'supervisor' && ['created', 'submitted'].includes(this.subtestAttempt.status);
    },

    showResolveSpeakingCancellationButton () {
      return App.role === 'supervisor' && this.subtestAttempt.speaking_status === 'cancellation-requested';
    },

    showResolveWritingCancellationButton () {
      return App.role === 'supervisor' && this.subtestAttempt.writing_status === 'cancellation-requested';
    },

    showUpdatePlatformButton () {
      return App.role === 'supervisor'
        && [4, 5].includes(this.subtestAttempt.subtest.subtest_type_id)
        && !['cancelled', 'cancellation-requested'].includes(this.subtestAttempt.speaking_status)
        && !this.subtestAttempt.speaking_passed_appointment
        && this.subtestAttempt.platform === 'invitation';
    },

    showUpdateSpeakingStatusButton () {
      let isReviewer = App.role === 'reviewer' && this.subtestAttempt.reviewer_id === App.user.id;

      return isReviewer && [4, 5].includes(this.subtestAttempt.subtest.subtest_type_id)
        && !['cancelled', 'cancellation-requested'].includes(this.subtestAttempt.speaking_status)
        && this.subtestAttempt.speaking_passed_appointment;
    },

    graded () {
      let subtestType = this.subtestAttempt.subtest.subtest_type_id;

      if (this.subtestAttempt.subtest.grading_by_subtest_type) {
        if (subtestType === 3) {
          return this.subtestAttempt.writing_grade && this.subtestAttempt.reading_grade && this.subtestAttempt.listening_grade;
        }

        if (subtestType === 4) {
          return this.subtestAttempt.speaking_grade;
        }

        if (subtestType === 5) {
          return this.subtestAttempt.writing_grade && this.subtestAttempt.reading_grade && this.subtestAttempt.listening_grade && this.subtestAttempt.speaking_grade;
        }
      } else {
        if (subtestType === 3) {
          return this.subtestAttempt.writing_module_grade;
        }

        if (subtestType === 4) {
          return this.subtestAttempt.speaking_module_grade;
        }

        if (subtestType === 5) {
          return this.subtestAttempt.writing_module_grade && this.subtestAttempt.speaking_module_grade;
        }
      }
    },

    reviewed () {
      return this.subtestAttempt.status === 'completed';
    }
  },

  methods: {
    editSubtestAttempt (type, moduleType = null) {
      if (type === 'grade') {
        this.$parent.$emit('showGradeSubtestAttemptModal');
      }

      if (type === 'feedback') {
        this.$parent.$emit('showFeedbackSubtestAttemptModal');
      }

      if (type === 'assign') {
        this.$parent.$emit('showAssignSubtestAttemptModal');
      }

      if (type === 'cancel') {
        this.$parent.$emit('showCancelSubtestAttemptModal', moduleType);
      }

      if (type === 'update-speaking-status') {
        this.$parent.$emit('showUpdateSubtestAttemptSpeakingStatusModal');
      }

      if (type === 'update-platform') {
        this.$parent.$emit('showUpdateSubtestAttemptPlatformModal');
      }
    },
  }
};
</script>

<style>
.subtest-type {
    margin-top: 20px;
    padding: 20px;
    border: 1px solid #dee2e6;
    border-radius: 10px;
}

.subtest-file {
    margin-top: 5px;
    margin-bottom: 5px;
}

.next-to-button-icon {
    vertical-align: middle;
    width: 28px;
}
</style>
